import React from "react";

type BrandProps = {
    brandName: string | undefined;
};

const Brand = ({ brandName }: BrandProps) => {
    if (!brandName) return null;

    return <div>{brandName}</div>;
};

export default Brand;
